/**
 * A small "or" separator placed between the password form and the federated
 * provider buttons. Purely presentational; uses only `var(--color-*)` tokens.
 */
export function OrSeparator() {
  return (
    <div
      aria-hidden="true"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        margin: '1.25rem 0',
        color: 'var(--color-muted)',
        fontSize: '0.85rem',
      }}
    >
      <span style={{ flex: 1, height: '1px', backgroundColor: 'var(--color-border)' }} />
      <span>or</span>
      <span style={{ flex: 1, height: '1px', backgroundColor: 'var(--color-border)' }} />
    </div>
  );
}
